import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

/**
 * O que a plataforma conta sobre quem a usa.
 *
 * Esta página cobre APENAS a contagem de visitas acrescentada em agosto de
 * 2026 — não é o aviso de privacidade completo da plataforma. Os dados de
 * trabalho (nomes, horas, documentos, folha mensal) são tratados pela Blank
 * Personnel enquanto entidade empregadora e continuam por documentar aqui:
 * base legal, prazos de conservação e quem lhes acede. Ver a nota no fim.
 */
export default function Privacidade() {
  return (
    <div className="mx-auto max-w-2xl px-4 py-10">
      <Link
        to="/"
        className="mb-6 inline-flex items-center gap-1.5 text-sm font-medium text-tinta-500
                   hover:text-tinta-700 dark:text-tinta-400 dark:hover:text-papel-200"
      >
        <ArrowLeft className="h-4 w-4" aria-hidden /> Voltar
      </Link>

      <h1 className="text-2xl font-semibold">Privacidade</h1>
      <p className="mt-1 text-sm text-tinta-500 dark:text-tinta-400">
        Atualizado a 5 de agosto de 2026
      </p>

      <div className="mt-8 space-y-4 text-sm leading-relaxed text-tinta-700 dark:text-papel-300">
        <h2 className="text-lg font-semibold text-tinta-900 dark:text-papel-100">
          Contagem de utilização
        </h2>
        <p>
          Esta plataforma conta as visitas às suas páginas. A contagem é feita pela
          <strong> Snip.work</strong>, que desenvolve e mantém a plataforma, e serve para
          saber se está a ser usada e se está disponível.
        </p>
        <p>O que é registado, por dia:</p>
        <ul className="list-disc space-y-1 pl-5">
          <li>o endereço da página e o dia da visita;</li>
          <li>
            uma impressão digital de sentido único do endereço IP e do navegador, misturada
            com a data do dia — a mesma pessoa é contada uma vez por dia e não pode ser
            reconhecida no dia seguinte;
          </li>
          <li>o país e a região a que o endereço IP corresponde, e o tipo de aparelho.</li>
        </ul>
        <p>
          Não são usados cookies e o endereço IP não é guardado em lado nenhum. As impressões
          digitais são apagadas ao fim de três dias; ficam apenas os totais por dia.
        </p>

        <div className="rounded-lg border border-amber-200 bg-amber-50 p-4 text-amber-900
                        dark:border-amber-900/60 dark:bg-amber-950/40 dark:text-amber-200">
          <p className="font-medium">Uma nota honesta sobre o que isto significa aqui</p>
          <p className="mt-1">
            Num site público, estes números são verdadeiramente anónimos. Nesta plataforma
            não são tanto: quem entra é um grupo pequeno de pessoas com conta e nome, por
            isso «uma visita a partir de Lisboa» diz mais do que diria num sítio com milhares
            de visitantes. Os números não são usados para avaliar ninguém, e não são ligados
            à conta com que iniciou sessão.
          </p>
        </div>

        <h2 className="pt-4 text-lg font-semibold text-tinta-900 dark:text-papel-100">
          Os dados de trabalho
        </h2>
        <p>
          Nomes, horas registadas, serviços, documentos e folha mensal são tratados pela
          Blank Personnel enquanto entidade empregadora, e não pela Snip.work.
        </p>
        <p className="rounded-lg border border-papel-300 bg-papel-100 p-4 text-tinta-600
                      dark:border-tinta-700 dark:bg-tinta-800 dark:text-tinta-300">
          <strong>Por escrever:</strong> a base legal de cada categoria, quanto tempo cada
          uma é conservada, quem lhes acede e como pedir uma cópia ou a eliminação. Esta
          parte tem de ser escrita pela Blank Personnel — a Snip.work não a pode inventar.
        </p>
      </div>

      <p className="mt-10 text-center text-xs text-tinta-400">snip.work · beta</p>
    </div>
  );
}
